"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.Circle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const lib_1 = require("./lib");
const StyledCircle = app_1.styled.div `
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 3rem;
  border-radius: 50%;
  overflow: hidden;
  color: white;
  text-align: center;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  > div {
    position: absolute;
    background-position: center;
    background-size: cover;
  }
`;
function Circle({ children, className, size = '2.375rem', }) {
    return ((0, jsx_runtime_1.jsx)(StyledCircle, Object.assign({ className: className, css: (0, app_1.css) `
        width: ${size};
        height: ${size};
        line-height: ${size};
        font-size: calc(0.4 * ${size});
      ` }, { children: children })));
}
exports.Circle = Circle;
function getInitials(name) {
    var _a;
    const upperCased = name.toUpperCase();
    const initials = (_a = upperCased.match(/(\b\w)/gu)) === null || _a === void 0 ? void 0 : _a.slice(0, 2);
    if ((initials === null || initials === void 0 ? void 0 : initials.length) === 2) {
        return initials.join('');
    }
    return upperCased.slice(0, 2);
}
function Avatar({ name = '', image, size = '2.375rem', className, }) {
    const initials = name ? getInitials(name) : null;
    return ((0, jsx_runtime_1.jsx)(Circle, Object.assign({ className: className, css: (0, app_1.css) `
        background-color: ${(theme) => (0, lib_1.getColorFor)(name, theme)};
      `, size: size }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: image ? { backgroundImage: `url(${image})` } : undefined }), !image && (initials !== null && initials !== void 0 ? initials : (0, jsx_runtime_1.jsx)(svg_1.SvgUser, {}))] }) })));
}
exports.Avatar = Avatar;
